import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SessionService } from '../common/session.service';
import { PartnerCtlService, ReceiptControllerService, TransactionCtlService } from '../api/services';
import { PartnerDto, PaymentResponseDto, TransactionDto } from '../api/models';
import { CommonModule } from '@angular/common';
import * as bootstrap from 'bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
  selector: 'app-duplicata',
  imports: [CommonModule,
      ReactiveFormsModule,
    NgxPaginationModule
  ],
  templateUrl: './duplicata.component.html',
  styleUrl: './duplicata.component.css'
})
export class DuplicataComponent implements OnInit {

  pageConfig= {
    itemsPerPage: 12,
    currentPage: 0,
    totalItems: 0
   };
  message:string='';
  receipt?:PaymentResponseDto;
  transactions?:any=Array.of();
  partnerType?:string;
  searchForm:FormGroup;
  idPartner?:number;
  reference?:string;
  partner?:PartnerDto;
   merchants?:Array<PartnerDto>;
   classe?:any;
   reliquat?:any;
   receiptType='';
  taxes: [string, number][] = [];
  constructor( private receiptService:ReceiptControllerService,
               private partnerService: PartnerCtlService,
               private session: SessionService,
               private formBuilder:FormBuilder,
    ){
      this.searchForm = this.formBuilder.group({
        idPartner :['', [Validators.required]],
        reference:['',[Validators.required]]
      });
      
      }
      ngOnInit(): void {
        this.partner=this.session.getSessionInfo().partner;
          this.partnerType=this.partner?.type;
          if(this.partner?.canBeParent==true){
            this.loadMerchants();
          }else {
            this.idPartner =this.session.getSessionInfo().partner?.id;
            this.searchForm.controls['idPartner'].setValue(this.idPartner);
            
          }
        }
      loadMerchants(){
    this.partnerService.getChildren(
      this.session.getSessionInfo().partner?.id!!,
      "MERCHANT",
      1000,
      0
    ).subscribe(
      {
        next:(resp)=>{
          this.merchants = resp.content;
        }
      }
    )
  }
  onFindTransaction(){
    let form = this.searchForm.value;
    this.idPartner=form.idPartner;
    this.reference=form.reference;
    
     console.log(form);
     this.findTransaction(this.idPartner!!,this.reference!!,0,12);
     
  }
  onDetailsTrx(trx:PaymentResponseDto){
    this.receipt=trx;
    this.classe =trx.bill;
    if(this.receipt.taxes){
              this.taxes =Object.entries(this.receipt.taxes);
              }
    if(this.receipt?.subscription){
             this.reliquat = this.receipt.subscription.reliquat;
             this.classe=this.receipt.subscription.classes?.at(0);
             this.receiptType='Reçu reinscription école';
          }else if(this.receipt.bill){
            this.receiptType="Reçu mensualité scolaire";
          }
    const elt =document.getElementById('detailsTrx');
                        const modAdd = new bootstrap.Modal(elt!!);
                        modAdd.show();

  }
  onNextPage(event:number){
    console.log(event);
    this.findTransaction(this.idPartner!!, this.reference!!, event-1);
  }
  findTransaction(idPartner:number,reference:string, page:number=0,size:number=12){
    this.receiptService.getDuplicata(
      reference,
      idPartner,
      page,
      size
    ).subscribe(
      {
        next:(resp)=>{
          
          if(resp.content?.length ==0){
                        this.message = 'Aucune opération  trouvée';
                                
                        const elt =document.getElementById('modalResult');
                        const modAdd = new bootstrap.Modal(elt!!);
                        modAdd.show();
          
                      }
                      else {
                        this.transactions =resp.content;
                        this.pageConfig.currentPage= resp.page?.number!!+1;
                        this.pageConfig.itemsPerPage= resp.page?.size!!;
                        this.pageConfig.totalItems =  resp.page?.totalElements!!;
                      }
          
        },
        error:(err)=>{
          this.message = err.message;
                                
                        const elt =document.getElementById('modalResult');
                        const modAdd = new bootstrap.Modal(elt!!);
                        modAdd.show();
        }
      }
    )
  }
}
